import styled from "styled-components";
import media from "styled-media-query";

import vector from '../../assets/vector-illustration-top.jpg';

export const SectionMission = styled.section`
  padding: 80px 0 80px;
  background-color: #144BC8;

  ${media.between('1024px','1366px')`
      button {
        width: 260px;
        height: 60px;
        font-size: 18px;
      }
  `}

  ${media.greaterThan('1024px')`
    background-image: url(${vector});
  `}

  ${media.lessThan('1024px')`
    padding-top: 150px;
  `}

  ${media.lessThan('768px')`
    padding-top: 100px;
  `}

  background-position: top center;
  background-size: contain;
  position: relative;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 860px;

    ${media.lessThan('1366px')`
      max-width: 640px;
    `}
  }

  .header-mission {
    background-color: #B4E128;
    width: 100%;
    max-width: 860px;
    height: 171px;
    padding: 0 84px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.lessThan('1366px')`
      height: 131px;
    `}

    &.border {
      border-radius: 8px;
    }

    ${media.lessThan('1024px')`
      min-width: 396px;
      height: auto;
      padding: 0 20px;
    `}

    .title {
      margin: -30px 0 20px;
      display: block;
      height: 93px;
      max-width: 579px;
      width: 100%;
      border-radius: 8px;
      background-color: #000000;
      border: 2px solid #FFFFFF;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;

      ${media.lessThan('1366px')`
        max-width: 420px;
        height: 80px;
        margin: -30px 0 10px;
      `}

      ${media.lessThan('1024px')`
        min-width: 337px;
        height: 108px;
        margin: -70px 0 10px;
      `}

      h2 {
        font-weight: 900;
        font-size: 28px;
        line-height: 34px;
        text-align: center;
        text-transform: uppercase;
        color: #FFFFFF;
        padding: 10px 0 15px;

        ${media.lessThan('1366px')`
          font-size: 21px;
          line-height: 28px;
        `}

        ${media.lessThan('1024px')`
          font-size: 24px;
          line-height: 29px;
          padding: 10px 9px;
        `}
      }
    }

    p {
      font-weight: 900;
      font-size: 24px;
      line-height: 29px;
      text-align: center;
      text-transform: uppercase;

      color: #262C2B;

      text-shadow: 0px 4px 0px #FFFFFF;
      margin-bottom: 27px;

      ${media.lessThan('1366px')`
        font-size: 17px;
        line-height: 25px;
      `}

      ${media.lessThan('1024px')`
        font-size: 22px;
        line-height: 27px;
        margin-bottom: 22px;
      `}
    }
    
  }

  .container-video {
    ${media.lessThan('1024px')`
      padding: 0 10px;
    `}
  }

  .card-video {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 40px;
    background: #FFFFFF;
    border-radius: 16px;
    width: 100%;
    max-width: 860px;
    padding: 17px 16px 40px;

    ${media.lessThan('1366px')`
      padding: 12px 12px 30px;
    `}

    ${media.lessThan('1024px')`
      padding: 6px 7px 31px;
      border-radius: 8px;
    `}

    .video {
      margin-bottom: 46px;
      height: 0;
      padding-bottom: 56.25%;
      position: relative;
      width: 100%;

      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

    p {
      font-weight: 600;
      font-size: 20px;
      text-align: center;
      line-height: 24px;
      color: #000000;

      & + p {
        margin: 40px 0 48px;
      }


      ${media.lessThan('1366px')`
        font-size: 15px;
        line-height: 20px;
        & + p {
          margin: 20px 0 28px;
        }
      `}

      ${media.lessThan('1024px')`
        font-size: 16px;
        line-height: 20px;
        padding: 0 7px;

        & + p {
          margin: 27px 0 29px;
        }
      `}
    }

    .note {
      margin-top: 27px;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;

      ${media.lessThan('1366px')`
        margin-top: 20px;
        font-size: 15px;
      `}

      ${media.lessThan('1024px')`
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-top: 16px;
        padding: 0 18px;
      `}
    }
  }
`